import { render, staticRenderFns } from "./BlindBoxList.vue?vue&type=template&id=448fa3ff&scoped=true"
import script from "./BlindBoxList.vue?vue&type=script&lang=js"
export * from "./BlindBoxList.vue?vue&type=script&lang=js"
import style0 from "./BlindBoxList.vue?vue&type=style&index=0&id=448fa3ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fa3ff",
  null
  
)

export default component.exports